// extracted by mini-css-extract-plugin
export var carrierTab = "_46-0";
export var carrierTabActive = "_46-1 _46-0";
export var carrierTabInactive = "_46-2 _46-0";
export var carrierTabLabel = "_46-3";
export var carrierTabLabelActive = "_46-4 _46-3";
export var carrierTabLabelInactive = "_46-5 _46-3";
export var carrierTabPercentage = "_46-6";
export var carrierTabPercentageActive = "_46-7 _46-6";
export var carrierTabPercentageInactive = "_46-8 _46-6";
export var carrierTabWinnable = "_46-9";
export var carrierTabWinnableActive = "_46-a _46-9";
export var carrierTabWinnableInactive = "_46-b _46-9";
export var comparisonContainer = "_46-d";
export var missingRateButton = "_46-n";
export var missingRateButtonActive = "_46-o _46-n";
export var missingRateButtonInactive = "_46-p _46-n";
export var missingRateButtonLabel = "_46-q";
export var missingRateButtonLabelActive = "_46-r _46-q";
export var missingRateButtonLabelInactive = "_46-s _46-q";
export var sidebar = "_46-c";
export var strategyButton = "_46-e";
export var strategyButtonActive = "_46-f _46-e";
export var strategyButtonDescription = "_46-k";
export var strategyButtonDescriptionActive = "_46-l _46-k";
export var strategyButtonDescriptionInactive = "_46-m _46-k";
export var strategyButtonInactive = "_46-g _46-e";
export var strategyButtonLabel = "_46-h";
export var strategyButtonLabelActive = "_46-i _46-h";
export var strategyButtonLabelInactive = "_46-j _46-h";
export var unitToggleButton = "_46-t";
export var unitToggleButtonActive = "_46-u _46-t";
export var unitToggleButtonInactive = "_46-v _46-t";
export var unitToggleButtonLabel = "_46-w";
export var unitToggleButtonLabelActive = "_46-x _46-w";
export var unitToggleButtonLabelInactive = "_46-y _46-w";